import { useMediaQuery, useTheme } from '@mui/material'

/**
 * Sizes for the dashboard charts.
 *
 * The charts used to hold a 480px minimum width and scroll sideways inside their card on a phone.
 * They now always fit: below `sm` they are shorter (three 300px charts were a screen and a half
 * of scrolling before the lists), the axis text is smaller, the Y axis narrower, and
 * `minTickGap` lets recharts drop date labels instead of overlapping them.
 */
export function useChartLayout() {
  const theme = useTheme()
  const isPhone = useMediaQuery(theme.breakpoints.down('sm'))
  return isPhone
    ? { height: 200, fontSize: 10, minTickGap: 24, yAxisWidth: 32 }
    : { height: 300, fontSize: 12, minTickGap: 8, yAxisWidth: 48 }
}
